// 테마 선택 드롭다운 — 팔레트 버튼 클릭 시 색상 목록 표시
import { useEffect, useRef, useState } from 'react';
import { THEMES, useThemeStore } from '../lib/themeStore';

export function ThemeSwitcher() {
  const { theme, setTheme } = useThemeStore();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const current = THEMES.find((t) => t.id === theme)!;

  useEffect(() => {
    function onOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('mousedown', onOutside);
    return () => document.removeEventListener('mousedown', onOutside);
  }, []);

  return (
    <div className="theme-switcher" ref={ref}>
      <button
        className="btn btn-ghost btn-sm"
        onClick={() => setOpen((v) => !v)}
        title={`테마: ${current.label}`}
        style={{ display: 'flex', alignItems: 'center', gap: 6 }}
      >
        <span
          className="theme-swatch-btn active"
          style={{ background: current.swatch, width: 14, height: 14, border: 'none', boxShadow: 'none' }}
        />
        🎨 {current.label}
      </button>

      {open && (
        <div className="theme-picker">
          {THEMES.map((t) => (
            <button
              key={t.id}
              className={`theme-picker-item ${t.id === theme ? 'active' : ''}`}
              onClick={() => { setTheme(t.id); setOpen(false); }}
            >
              <span className="theme-picker-dot" style={{ background: t.swatch }} />
              {t.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
